module.exports = __webpack_public_path__ + "static/ma-6-9df130f69d25a5fc5e15e0ce49407121.png";